import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { store } from './Redux/store';
import TaxItems from './TaxItems';
import TaxItemForm from "./TaxItemForm";

function Index({ taxItems, qbIntegrationEnabled }) {
  return (
    <Provider store={store}>
      <TaxItems taxItems={taxItems} qbIntegrationEnabled={qbIntegrationEnabled} />
    </Provider>
  );
}

Index.propTypes = {
  taxItems: PropTypes.array.isRequired,
  qbIntegrationEnabled: PropTypes.bool
};

export default Index;
